import Example01 from "../../../../content/posts/2019/0907-00/Example01";
import * as React from 'react';
export default {
  Example01,
  React
};